import type { ModuleInstance } from "ee/constants/ModuleInstanceConstants";

export const generateModuleInstance = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  moduleInstance: ModuleInstance,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  moduleInstanceEntities: any,
) => {
  return {
    configEntity: null,
    unEvalEntity: null,
  };
};
